import SvgClose from "../../utilities/SvgClose"

export default function Closed() {
  return (
    <div className={"h-full lg:animate-fadeIn p-1 opacity-70"}>
      <SvgClose height={"h-full"} />
    </div>
  )
}
